<template>
  <nav :class="['navbar navbar-expand-lg navbar-dark custom-navbar', { 'scrolled': isScrolled }]">
    <div class="container-fluid">
      <!-- Left section (Home, Buy, Sell) - visible only on desktop (above 990px) -->
      <ul v-if="isDesktop" class="navbar-nav flex-row d-none d-lg-flex" id="desktop-nav">

        <li class="nav-item navItem">
          <a class="nav-link fw-bold" href="/cars">

            In Stock</a>
        </li>
        <li class="nav-item navItem">
          <a class="nav-link fw-bold" href="Sell-your-Vehicle">
            Sell Your Car</a>
        </li>
        <li class="nav-item navItem">
          <a class="nav-link fw-bold" href="/WarrantyInformation">
            Warranty</a>
        </li>
      </ul>

      <!-- Center logo (outside collapsible menu) -->
      <a class="navbar-brand mx-auto" href="/">
        <img src="../assets/weblogo.png" class="img-fluid" style="width: 200px;">
      </a>

      <!-- Right section (Toggle button for mobile) -->
      <button v-if="!isDesktop" class="navbar-toggler" type="button" data-bs-toggle="collapse"
        data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
    </div>

    <!-- Collapsible menu for mobile view (below 990px) -->
    <div class="collapse navbar-collapse" id="navbarNav">
      <!-- Combined menu for mobile view (Home, Buy, Sell + Contact, Find Us, Login) -->
      <ul class="navbar-nav mx-auto" id="mobile-nav">
        <!-- These links should always be visible -->
        <div v-if="!isDesktop">

          <li class="nav-item navItem">
            <a class="nav-link fw-bold" href="/cars">
              <svg fill="#ffffff" width="25px" height="25px" viewBox="0 0 32 32" version="1.1"
                xmlns="http://www.w3.org/2000/svg" stroke="#ffffff">
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                  <title>car</title>
                  <path
                    d="M27 22h-23c-1.104 0-2-0.896-2-2v-5c0-1.104 0.896-2 2-2h1c0 0 1.479-4.5 1.916-6s0.896-2 2.001-2h13.166c1.104 0 1.438 0.312 2 2s1.917 6 1.917 6h1c1.104 0 2 0.896 2 2v5c0 1.104-0.896 2-2 2zM9 20h13v-1h-13v1zM22 13c0-1.104-0.896-2.125-2-2.125s-2 1.021-2 2.125c0 0.026 4 0.026 4 0zM9 18h13v-1h-13v1zM9 16h13v-1h-13v1zM4.062 17c0 1.104 0.896 2 2 2s2-0.896 2-2-0.896-2-2-2-2 0.896-2 2zM23.083 7c-0.25-0.688-0.447-1-1-1h-6.083v1h0.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-2c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h0.5v-1h-6.083c-0.553 0-0.751 0.125-1 1-0.251 0.875-1.917 6-1.917 6h11.46c0.023-1.364 1.13-2.643 2.495-2.643s2.472 1.278 2.496 2.643h2.549c0 0-1.667-5.312-1.917-6zM24.938 15.062c-1.104 0-2 0.896-2 2s0.896 2 2 2 2-0.896 2-2-0.896-2-2-2zM7 25.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5v-2.5h3v2.5zM27 25.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5v-2.5h3v2.5z">
                  </path>
                </g>
              </svg>
              In Stock</a>
          </li>
          <li class="nav-item navItem">
            <a class="nav-link fw-bold" href="/Sell-your-Vehicle">
              <svg width="25px" height="25px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                stroke="#ffffff">
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    d="M15 16H10.8M10.2 16H10.8M10.8 16C10.8 13.5453 10.8 10.8571 10.8 9.71429C10.8 8.57143 11.4 8 12.6 8C13.8 8 14.4 8.57143 14.4 9.71429M9 12.3636H12.6"
                    stroke="#ffffff" stroke-width="0.8399999999999999" stroke-linecap="round" stroke-linejoin="round">
                  </path>
                  <circle cx="12" cy="12" r="10" stroke="#ffffff" stroke-width="0.8399999999999999"></circle>
                </g>
              </svg>
              Sell Your Car
            </a>
          </li>
          <li class="nav-item navItem">
            <a class="nav-link fw-bold" href="/WarrantyInformation">
              <svg fill="#ffffff" height="25px" width="25px" version="1.1" id="Capa_1"
                xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 290.07 290.07" xml:space="preserve" stroke="#ffffff">
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                  <path color-rendering="auto" image-rendering="auto" shape-rendering="auto" color-interpolation="sRGB"
                    d="M54.922,0 c-2.759,0.042-4.963,2.311-4.924,5.07v280c0,2.761,2.239,5,5,5l180.821-0.062c2.125-0.286,4.06-1.783,4.234-4.514L240.073,5 c0-2.761-2.239-5-5-5h-180v0.01c-0.05,0-0.1-0.01-0.148-0.01L54.922,0z M59.998,10h170.073v270.07H59.998V10z M94.998,20.07 c-2.761,0-4.999,2.239-5,5v10c0,2.761,2.239,5,5,5h100c2.762,0,5-2.239,5-5v-10c0-2.761-2.238-5-5-5H94.998z M94.998,50.07 c-2.761,0-4.999,2.239-5,5v10c0,2.761,2.239,5,5,5h100c2.762,0,5-2.239,5-5v-10c0-2.761-2.238-5-5-5H94.998z M94.998,100.07 c-6.761-0.096-6.761,10.096,0,10h100c6.762,0.096,6.762-10.096,0-10H94.998z M94.998,120.07c-6.761-0.096-6.761,10.096,0,10h100 c6.762,0.096,6.762-10.096,0-10H94.998z M94.998,140.07c-6.761-0.096-6.761,10.096,0,10h100c6.762,0.096,6.762-10.096,0-10H94.998z M144.998,180.07c-13.748,0-25,11.252-25,25c0,3.573,0.767,6.975,2.133,10.057l-11.91,38.465c-1.243,4.018,2.727,7.682,6.633,6.121 l8.144-3.256l8.143,3.256c2.902,1.161,6.146-0.597,6.76-3.662l5.095-25.48l5.098,25.48c0.769,3.999,4.705,4.831,7.387,3.412 l7.517-3.006l7.033,2.812c3.405,2.526,9.499-0.526,7.723-5.738l-12.203-37.709c1.567-3.262,2.447-6.909,2.447-10.752 C169.998,191.322,158.746,180.07,144.998,180.07L144.998,180.07z M144.998,190.07c8.344,0,15,6.656,15,15s-6.656,15-15,15 c-8.343,0-15-6.656-15-15S136.655,190.07,144.998,190.07z M129.625,224.738c1.725,1.353,3.628,2.492,5.67,3.359l-4.021,20.098 l-4.42-1.768c-1.192-0.477-2.521-0.477-3.713,0l-0.266,0.106L129.625,224.738z M160.018,225.018l6.941,21.453l-0.105-0.043 c-0.621-0.248-1.285-0.369-1.953-0.356c-0.604,0.011-1.2,0.132-1.76,0.356l-4.42,1.768l-4.02-20.096 C156.605,227.291,158.387,226.25,160.018,225.018L160.018,225.018z">
                  </path>
                </g>
              </svg>
              Warranty
            </a>
          </li>

        </div>
        <ul v-if="isDesktop" class="navbar-nav flex-row d-none d-lg-flex ms-auto">

          <li class="nav-item navItem">
            <a class="nav-link fw-bold" href="mailto:awtradecentre@yahoo.com">
              Email Us</a>
          </li>
          <li class="nav-item navItem">
            <a class="nav-link fw-bold" href="tel:07497670847">
              Book A viewing</a>
          </li>
          <li class="nav-item navItem">
            <a class="nav-link fw-bold" href="/findus">
              Find Us</a>
          </li>
        </ul>
      </ul>

    </div>

    <!-- Bottom bar for mobile (visible only below 990px) -->
    <div v-if="!isDesktop" class="mobile-bottom-bar">

      <a class="bottom-link" href="mailto:awtradecentre@yahoo.com"><svg width="25px" height="25px" viewBox="0 0 24 24"
          fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M3.75 5.25L3 6V18L3.75 18.75H20.25L21 18V6L20.25 5.25H3.75ZM4.5 7.6955V17.25H19.5V7.69525L11.9999 14.5136L4.5 7.6955ZM18.3099 6.75H5.68986L11.9999 12.4864L18.3099 6.75Z"
              fill="#ffffff"></path>
          </g>
        </svg>
      </a>
      <a class="bottom-link" href="tel:07497670847"><svg width="25px" height="25px" viewBox="0 0 24.00 24.00"
          fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff" stroke-width="0.00024000000000000003">
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC"
            stroke-width="0.24000000000000005"></g>
          <g id="SVGRepo_iconCarrier">
            <path
              d="M16.1007 13.359L15.5719 12.8272H15.5719L16.1007 13.359ZM16.5562 12.9062L17.085 13.438H17.085L16.5562 12.9062ZM18.9728 12.5894L18.6146 13.2483L18.9728 12.5894ZM20.8833 13.628L20.5251 14.2869L20.8833 13.628ZM21.4217 16.883L21.9505 17.4148L21.4217 16.883ZM20.0011 18.2954L19.4723 17.7636L20.0011 18.2954ZM18.6763 18.9651L18.7459 19.7119H18.7459L18.6763 18.9651ZM8.81536 14.7266L9.34418 14.1947L8.81536 14.7266ZM4.00289 5.74561L3.2541 5.78816L3.2541 5.78816L4.00289 5.74561ZM10.4775 7.19738L11.0063 7.72922H11.0063L10.4775 7.19738ZM10.6342 4.54348L11.2346 4.09401L10.6342 4.54348ZM9.37326 2.85908L8.77286 3.30855V3.30855L9.37326 2.85908ZM6.26145 2.57483L6.79027 3.10667H6.79027L6.26145 2.57483ZM4.69185 4.13552L4.16303 3.60368H4.16303L4.69185 4.13552ZM12.0631 11.4972L12.5919 10.9654L12.0631 11.4972ZM16.6295 13.8909L17.085 13.438L16.0273 12.3743L15.5719 12.8272L16.6295 13.8909ZM18.6146 13.2483L20.5251 14.2869L21.2415 12.9691L19.331 11.9305L18.6146 13.2483ZM20.8929 16.3511L19.4723 17.7636L20.5299 18.8273L21.9505 17.4148L20.8929 16.3511ZM18.6067 18.2184C17.1568 18.3535 13.4056 18.2331 9.34418 14.1947L8.28654 15.2584C12.7186 19.6653 16.9369 19.8805 18.7459 19.7119L18.6067 18.2184ZM9.34418 14.1947C5.4728 10.3453 4.83151 7.10765 4.75168 5.70305L3.2541 5.78816C3.35456 7.55599 4.14863 11.144 8.28654 15.2584L9.34418 14.1947ZM10.7195 8.01441L11.0063 7.72922L9.9487 6.66555L9.66189 6.95073L10.7195 8.01441ZM11.2346 4.09401L9.97365 2.40961L8.77286 3.30855L10.0338 4.99296L11.2346 4.09401ZM5.73263 2.04299L4.16303 3.60368L5.22067 4.66736L6.79027 3.10667L5.73263 2.04299ZM10.1907 7.48257C9.66189 6.95073 9.66117 6.95144 9.66045 6.95216C9.66021 6.9524 9.65949 6.95313 9.659 6.95362C9.65802 6.95461 9.65702 6.95561 9.65601 6.95664C9.65398 6.95871 9.65188 6.96086 9.64972 6.9631C9.64539 6.96759 9.64081 6.97245 9.63599 6.97769C9.62634 6.98816 9.61575 7.00014 9.60441 7.01367C9.58174 7.04072 9.55605 7.07403 9.52905 7.11388C9.47492 7.19377 9.41594 7.2994 9.36589 7.43224C9.26376 7.70329 9.20901 8.0606 9.27765 8.50305C9.41189 9.36833 10.0078 10.5113 11.5343 12.0291L12.5919 10.9654C11.1634 9.54499 10.8231 8.68059 10.7599 8.27309C10.7298 8.07916 10.761 7.98371 10.7696 7.96111C10.7748 7.94713 10.7773 7.9457 10.7709 7.95525C10.7677 7.95992 10.7624 7.96723 10.7541 7.97708C10.75 7.98201 10.7451 7.98759 10.7394 7.99381C10.7365 7.99692 10.7335 8.00019 10.7301 8.00362C10.7285 8.00534 10.7268 8.00709 10.725 8.00889C10.7241 8.00979 10.7232 8.0107 10.7223 8.01162C10.7219 8.01208 10.7212 8.01278 10.7209 8.01301C10.7202 8.01371 10.7195 8.01441 10.1907 7.48257ZM11.5343 12.0291C13.0613 13.5474 14.2096 14.1383 15.0763 14.2713C15.5192 14.3392 15.8763 14.285 16.1472 14.1841C16.28 14.1346 16.3858 14.0763 16.4658 14.0227C16.5058 13.9959 16.5392 13.9704 16.5663 13.9479C16.5799 13.9367 16.5919 13.9262 16.6024 13.9166C16.6077 13.9118 16.6126 13.9073 16.6171 13.903C16.6194 13.9008 16.6215 13.8987 16.6236 13.8967C16.6246 13.8957 16.6256 13.8947 16.6266 13.8937C16.6271 13.8932 16.6279 13.8925 16.6281 13.8923C16.6288 13.8916 16.6295 13.8909 16.1007 13.359C15.5719 12.8272 15.5726 12.8265 15.5733 12.8258C15.5735 12.8256 15.5742 12.8249 15.5747 12.8244C15.5756 12.8235 15.5765 12.8226 15.5774 12.8217C15.5793 12.82 15.581 12.8183 15.5827 12.8166C15.5862 12.8133 15.5895 12.8103 15.5926 12.8074C15.5988 12.8018 15.6044 12.7969 15.6094 12.7929C15.6192 12.7847 15.6265 12.7795 15.631 12.7764C15.6403 12.7702 15.6384 12.773 15.6236 12.7785C15.5991 12.7876 15.501 12.8189 15.3038 12.7886C14.8905 12.7253 14.02 12.3853 12.5919 10.9654L11.5343 12.0291ZM9.97365 2.40961C8.95434 1.04802 6.94996 0.83257 5.73263 2.04299L6.79027 3.10667C7.32195 2.578 8.26623 2.63181 8.77286 3.30855L9.97365 2.40961ZM4.75168 5.70305C4.73201 5.35694 4.89075 4.9954 5.22067 4.66736L4.16303 3.60368C3.62571 4.13795 3.20329 4.89425 3.2541 5.78816L4.75168 5.70305ZM19.4723 17.7636C19.1975 18.0369 18.9029 18.1908 18.6067 18.2184L18.7459 19.7119C19.4805 19.6434 20.0824 19.2723 20.5299 18.8273L19.4723 17.7636ZM11.0063 7.72922C11.9908 6.7503 12.064 5.2019 11.2346 4.09401L10.0338 4.99295C10.4373 5.53193 10.3773 6.23938 9.9487 6.66555L11.0063 7.72922ZM20.5251 14.2869C21.3429 14.7315 21.4703 15.7769 20.8929 16.3511L21.9505 17.4148C23.2908 16.0821 22.8775 13.8584 21.2415 12.9691L20.5251 14.2869ZM17.085 13.438C17.469 13.0562 18.0871 12.9616 18.6146 13.2483L19.331 11.9305C18.2474 11.3414 16.9026 11.5041 16.0273 12.3743L17.085 13.438Z"
              fill="#ffffff"></path>
          </g>
        </svg>
      </a>
      <a class="bottom-link fw-bold" href="/contact">
        <svg width="25px" height="25px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier">
            <path
              d="M4 7C4 5.11438 4 4.17157 4.58579 3.58579C5.17157 3 6.11438 3 8 3H16C17.8856 3 18.8284 3 19.4142 3.58579C20 4.17157 20 5.11438 20 7V15C20 17.8284 20 19.2426 19.1213 20.1213C18.2426 21 16.8284 21 14 21H10C7.17157 21 5.75736 21 4.87868 20.1213C4 19.2426 4 17.8284 4 15V7Z"
              stroke="#ffffff" stroke-width="2"></path>
            <path d="M15 18L15 21M9 18L9 21" stroke="#ffffff" stroke-width="2" stroke-linecap="round"></path>
            <path d="M9 8L15 8" stroke="#ffffff" stroke-width="2" stroke-linecap="round"></path>
            <path d="M9 12L15 12" stroke="#ffffff" stroke-width="2" stroke-linecap="round"></path>
          </g>
        </svg>
      </a>
      <a class="bottom-link" href="/findus"><svg fill="#000000" width="25px" height="25px" viewBox="0 0 24 24"
          id="maps-location" data-name="Line Color" xmlns="http://www.w3.org/2000/svg" class="icon line-color">
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier">
            <path id="primary"
              d="M16,9h2.33a1,1,0,0,1,1,.84l1.67,10A1,1,0,0,1,20,21H4a1,1,0,0,1-1-1.16l1.67-10a1,1,0,0,1,1-.84H8"
              style="fill: none; stroke: #ffffff; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2;">
            </path>
            <path id="secondary" d="M16,7A4,4,0,0,0,8,7c0,4,4,8,4,8S16,11,16,7Z"
              style="fill: none; stroke: #ffffff; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2;">
            </path>
          </g>
        </svg></a>


    </div>



    <!-- Collapsible menu for mobile view (below 990px) -->
    <div class="collapse navbar-collapse" id="navbarNav">
      <!-- Combined menu for mobile view (Home, Buy, Sell + Contact, Find Us, Login) -->
      <ul class="navbar-nav mx-auto" id="mobile-nav">

      </ul>
    </div>
  </nav>

  <!-- Main content section below the navbar -->
  <div class="main-content">
    <!-- Your page content goes here -->
    <p></p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isDesktop: window.innerWidth > 990, // check if it's a desktop view
    };
  },
  created() {
    window.addEventListener('resize', this.handleResize);
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.isDesktop = window.innerWidth > 990;
    },
  },
};
</script>

<style scoped>
.custom-navbar {
  background-color: rgba(0, 0, 0, 0.635);
  padding: 0.5rem 1rem;
  z-index: 1030;
  position: fixed;
  width: 100%;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
}

.custom-navbar.scrolled {
  background-color: rgba(0, 0, 0, 0.9);
  /* darker when scrolled */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

/* Ensure content does not overlap navbar */
.main-content {
  padding-top: 80px;
  /* Space for navbar height (adjust if necessary) */
}

/* nav links */
.navbar-nav .nav-link:hover {
  color: rgb(145, 145, 145) !important;
}

.nav-link {
  color: rgb(191, 191, 191) !important;
  font-size: 1.1em !important;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
}

.navItem {
  margin-right: 15px;
}

.navItem {
  white-space: nowrap;
}

.navbar-nav {
  display: flex;
  flex-wrap: nowrap;
}


/* Bottom bar for mobile */
.mobile-bottom-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.683);
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1040;
  padding: 6px 0;
  /* creates spacing above and below the top border */
  border-top: 1px solid rgb(74, 74, 74);
  box-sizing: border-box;
}

.bottom-link {
  flex: 1;
  text-align: center;
  color: white;
  text-decoration: none;
  font-weight: bold;
  font-size: 1em;
  padding: 10px 0;
  /* space inside each box */
  box-sizing: border-box;
  position: relative;
}

/* Left border for spacing effect */
.bottom-link:nth-child(2)::before,
.bottom-link:nth-child(3)::before,
.bottom-link:nth-child(4)::before {
  content: '';
  position: absolute;
  top: 20%;
  bottom: 20%;
  left: 0;
  width: 1px;
  background-color: rgb(74, 74, 74);
}


.bottom-link:hover {
  background-color: rgba(255, 255, 255, 0.1);
  color: gray;
}

/* Bottom for mobile */


/* Mobile view (below 990px) */
@media screen and (max-width: 990px) {

  /* Hide desktop section (Home, Buy, Sell) */
  #desktop-nav {
    display: none !important;
  }

  /* Show mobile section (Home, Buy, Sell) */
  #mobile-nav {
    display: block !important;
  }

  .navbar-nav {
    flex-direction: column;
    /* Stack items vertically */
    align-items: center;
  }

  .navItem {
    margin-right: 0;
    /* Remove the margin for mobile */
    margin-bottom: 10px;
    /* Space between items */
  }

  /* Adjust navbar logo size for mobile */
  .navbar-brand img {
    width: 150px;
  }

  /* Make the collapsible menu fill the width of the screen */
  .collapse.navbar-collapse {
    width: 100%;
  }

  /* Make sure the navbar toggler button is in the center for mobile */
  .navbar-toggler {
    margin: 0 auto;
  }
}
</style>
